import { formatBigMoney, formatMoney, formatPercentage } from '../../../packages/utils/numberFormatters'
import { AxisPropOption } from '../ScatterPlot'

export const AXIS_OPTIONS_CONFIG = {
    avgTurnover: { type: 'currency', labelKey: 'charts.scatter.axis.avgTurnover' },
    commitment: { type: 'percent', labelKey: 'charts.scatter.axis.commitment' },
    dilutionActual: { type: 'percent', labelKey: 'charts.scatter.axis.dilutionActual' },
    dilutionMax: { type: 'percent', labelKey: 'charts.scatter.axis.dilutionMax' },
    feeCash: { type: 'percent', labelKey: 'charts.scatter.axis.feeCash' },
    feeUnits: { type: 'percent', labelKey: 'charts.scatter.axis.feeUnits' },
    offerSize: { type: 'currency', labelKey: 'charts.scatter.axis.offerSize' },
    preMoney: { type: 'currency', labelKey: 'charts.scatter.axis.preMoney' },
    priceChangeMax: { type: 'percent', labelKey: 'charts.scatter.axis.priceChangeMax' },
    priceChange3m: { type: 'percent', labelKey: 'charts.scatter.axis.priceChange3m' },
    priceChange6m: { type: 'percent', labelKey: 'charts.scatter.axis.priceChange6m' },
    priceChange12m: { type: 'percent', labelKey: 'charts.scatter.axis.priceChange12m' },
    subscribedSize: { type: 'currency', labelKey: 'charts.scatter.axis.subscribedSize' },
    subscriptionQuota: { type: 'percent', labelKey: 'charts.scatter.axis.subscriptionQuota' },
    subscriptionQuotaExclGuarantors: { type: 'percent', labelKey: 'charts.scatter.axis.subscriptionQuotaExclGuarantors' },
    subscriptionQuotaExclGuarantorsAndCommitments: {
        type: 'percent',
        labelKey: 'charts.scatter.axis.subscriptionQuotaExclGuarantorsAndCommitments',
    },
    totalCommitment: { type: 'percent', labelKey: 'charts.scatter.axis.totalCommitment' },
    vwap10d: { type: 'percent', labelKey: 'charts.scatter.axis.vwap10d' },
    vwap10dTerp: { type: 'percent', labelKey: 'charts.scatter.axis.vwap10dTerp' },
} as const

/** @deprecated Use AXIS_OPTIONS_CONFIG with getAxisLabel() */
export const AXIS_OPTIONS_LABELS = AXIS_OPTIONS_CONFIG

export const formatValue = (
    item: Partial<Record<AxisPropOption, number | null>>,
    prop: AxisPropOption,
    { locale, short = true }: { locale: string; short?: boolean },
): string => {
    if (item[prop] === null || item[prop] === undefined) return ''
    if (AXIS_OPTIONS_CONFIG[prop].type === 'percent') {
        return formatPercentage(item[prop], { decimals: short ? 0 : undefined, locale })
    }

    if (AXIS_OPTIONS_CONFIG[prop].type === 'currency') {
        if (short) return formatBigMoney(item[prop], { locale })
        return formatMoney(item[prop], { locale })
    }

    return item[prop].toString()
}

export const getAxisLabel = (prop: AxisPropOption, t: (key: string) => string) =>
    t(AXIS_OPTIONS_CONFIG[prop].labelKey)
